import { render, staticRenderFns } from "./Livestream.vue?vue&type=template&id=60a97aa5&scoped=true&"
import script from "./Livestream.vue?vue&type=script&lang=js&"
export * from "./Livestream.vue?vue&type=script&lang=js&"
import style0 from "./Livestream.vue?vue&type=style&index=0&id=60a97aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a97aa5",
  null
  
)

export default component.exports